"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminVisitPlanListItemDto = exports.AdminEventRsvpDto = exports.AdminVenueEventDto = exports.AdminVenueEventSummaryDto = exports.AdminVenueEventVenueDto = exports.AdminVenueEventUserDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const VenueEventExternalLink_dto_1 = require("./VenueEventExternalLink.dto");
class AdminVenueEventUserDto {}
exports.AdminVenueEventUserDto = AdminVenueEventUserDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventUserDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventUserDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventUserDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventUserDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventUserDto.prototype, "imageUrl", void 0);
class AdminVenueEventVenueDto {}
exports.AdminVenueEventVenueDto = AdminVenueEventVenueDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventVenueDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventVenueDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventVenueDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventVenueDto.prototype, "logoUrl", void 0);
class AdminVenueEventSummaryDto {}
exports.AdminVenueEventSummaryDto = AdminVenueEventSummaryDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventSummaryDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventSummaryDto.prototype, "name", void 0);
class AdminVenueEventDto {}
exports.AdminVenueEventDto = AdminVenueEventDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVenueEventDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "eventStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "eventEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "startDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "endDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "dayOfWeek", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "flyerUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false,
  type: VenueEventExternalLink_dto_1.VenueEventExternalLinkDto
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "externalLink", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "hideAddress", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "eventAddress", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueEventVisibility,
  required: false
}), __metadata("design:type", String)], AdminVenueEventDto.prototype, "visibility", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'When true, tickets for this event can be purchased in the app.'
}), __metadata("design:type", Boolean)], AdminVenueEventDto.prototype, "isTicketed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Ticket price in cents (USD).'
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "ticketPriceCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], AdminVenueEventDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminVenueEventDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminVenueEventDto.prototype, "rsvpedCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminVenueEventDto.prototype, "commentCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminVenueEventDto.prototype, "likeCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEventVenueDto
}), __metadata("design:type", AdminVenueEventVenueDto)], AdminVenueEventDto.prototype, "venue", void 0);
class AdminEventRsvpDto {}
exports.AdminEventRsvpDto = AdminEventRsvpDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminEventRsvpDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEventUserDto
}), __metadata("design:type", AdminVenueEventUserDto)], AdminEventRsvpDto.prototype, "user", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEventSummaryDto
}), __metadata("design:type", AdminVenueEventSummaryDto)], AdminEventRsvpDto.prototype, "event", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEventVenueDto
}), __metadata("design:type", AdminVenueEventVenueDto)], AdminEventRsvpDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminEventRsvpDto.prototype, "rsvpedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.EventSource,
  nullable: true,
  description: 'Where the user opened the event from; null for older app builds.'
}), __metadata("design:type", Object)], AdminEventRsvpDto.prototype, "source", void 0);
class AdminVisitPlanListItemDto {}
exports.AdminVisitPlanListItemDto = AdminVisitPlanListItemDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVisitPlanListItemDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEventUserDto
}), __metadata("design:type", AdminVenueEventUserDto)], AdminVisitPlanListItemDto.prototype, "user", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueEventVenueDto
}), __metadata("design:type", AdminVenueEventVenueDto)], AdminVisitPlanListItemDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueVisitPlanTimeSlot
}), __metadata("design:type", String)], AdminVisitPlanListItemDto.prototype, "timeSlot", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVisitPlanListItemDto.prototype, "plannedDate", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminVisitPlanListItemDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminVisitPlanListItemDto.prototype, "isPassed", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminVisitPlanListItemDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the plan owner has connected Google Calendar.'
}), __metadata("design:type", Boolean)], AdminVisitPlanListItemDto.prototype, "googleCalendarConnected", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether this specific plan has already been synced.'
}), __metadata("design:type", Boolean)], AdminVisitPlanListItemDto.prototype, "googleCalendarSynced", void 0);
//# sourceMappingURL=AdminVenueEvent.dto.js.map